import { render } from "./ConsentOtpButton.vue?vue&type=template&id=394dde62&scoped=true"
import script from "./ConsentOtpButton.vue?vue&type=script&lang=js"
export * from "./ConsentOtpButton.vue?vue&type=script&lang=js"

import "./ConsentOtpButton.vue?vue&type=style&index=0&id=394dde62&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394dde62"]])

export default __exports__